import Vue from "vue";
import Router from "vue-router";
import Index from "@/components/home";

import { routeList } from "@utils/sideList";
import utils from "@utils/utils";

Vue.use(Router);

let routes = [
  {
    path: "/",
    component: Index,
    meta: {
      requiresAuth: false
    },
    children: [
      {
        path: "",
        redirect: routeList.OVERVIEW
      },
      {
        path: routeList.OVERVIEW,
        component: () => import("@/components/overview/index.vue")
      },
      {
        path: routeList.PAGECOUNT,
        component: () => import("@/components/pageCount/index.vue")
      },
      {
        path: routeList.USERCOUNT,
        component: () => import("@/components/userCount/index.vue")
      },
      {
        path: routeList.CONSULTLIST,
        component: () => import("@/components/consultList/index.vue")
      },
      {
        path: routeList.CUSTOMERS,
        component: () => import("@/components/customers/index.vue"),
      },
      {
        path: 'customers/detail/:id',
        component: () => import("@/components/customers/detail.vue"),
      },
      {
        path: routeList.REGISTERLIST,
        component: () => import("@/components/registerList/index.vue")
      }
    ]
  },
  {
    path: "/signin",
    component: () => import("@/components/login/index.vue")
  }
];

const router = new Router({
  mode: "history",
  routes
});

router.beforeEach((to, from, next) => {
  if (!utils.getLoginInfo()) {
    if (to.path === "/signin") {
      next();
    } else {
      next({ path: "/signin" });
    }
  } else if (to.path === "/signin") {
    next({ path: routeList.OVERVIEW });
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js